import { forwardRef, memo } from 'react';
import { SvgIcon } from '@material-ui/core';

export const PromotionalSMS = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 115 110"
        data-fill-none
      >
        <mask
          id="mask0_1529_12714"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="115"
          height="110"
        >
          <rect
            width="115"
            height="110"
            rx="8"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask0_1529_12714)">
          <rect
            x="-36"
            y="-2"
            width="188"
            height="114"
            rx="6.07264"
            fill="#ECFEFF"
          />
          <path
            d="M8.53369 49.3253C8.53369 50.5487 9.01969 51.722 9.88477 52.5871C10.7498 53.4522 11.9232 53.9382 13.1466 53.9382H31.598L50.0495 72.3897V53.9382H59.2752C60.4987 53.9382 61.672 53.4522 62.537 52.5871C63.4021 51.722 63.8881 50.5487 63.8881 49.3253V17.0352C63.8881 15.8118 63.4021 14.6385 62.537 13.7734C61.672 12.9084 60.4987 12.4224 59.2752 12.4224H13.1466C11.9232 12.4224 10.7498 12.9084 9.88477 13.7734C9.01969 14.6385 8.53369 15.8118 8.53369 17.0352V49.3253Z"
            fill="#E3E3E3"
          />
          <path
            d="M59.2752 12.4224H13.1466C11.9232 12.4224 10.7498 12.9084 9.88477 13.7734C9.01969 14.6385 8.53369 15.8118 8.53369 17.0352V49.3253C8.53369 50.5487 9.01969 51.722 9.88477 52.5871C10.7498 53.4522 11.9232 53.9382 13.1466 53.9382H17.7594L59.2752 12.4224Z"
            fill="white"
          />
          <path
            d="M8.53369 49.3253C8.53369 50.5487 9.01969 51.722 9.88477 52.5871C10.7498 53.4522 11.9232 53.9382 13.1466 53.9382H31.598L50.0495 72.3897V53.9382H59.2752C60.4987 53.9382 61.672 53.4522 62.537 52.5871C63.4021 51.722 63.8881 50.5487 63.8881 49.3253V17.0352C63.8881 15.8118 63.4021 14.6385 62.537 13.7734C61.672 12.9084 60.4987 12.4224 59.2752 12.4224H13.1466C11.9232 12.4224 10.7498 12.9084 9.88477 13.7734C9.01969 14.6385 8.53369 15.8118 8.53369 17.0352V49.3253Z"
            stroke="#191919"
            strokeWidth="1.13862"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M22.3725 34.3335C22.0666 34.3335 21.7733 34.212 21.557 33.9958C21.3407 33.7795 21.2192 33.4862 21.2192 33.1803C21.2192 32.8745 21.3407 32.5811 21.557 32.3649C21.7733 32.1486 22.0666 32.0271 22.3725 32.0271"
            stroke="#191919"
            strokeWidth="1.13862"
          />
          <path
            d="M22.3726 34.3335C22.6784 34.3335 22.9717 34.212 23.188 33.9958C23.4043 33.7795 23.5258 33.4862 23.5258 33.1803C23.5258 32.8745 23.4043 32.5811 23.188 32.3649C22.9717 32.1486 22.6784 32.0271 22.3726 32.0271"
            stroke="#191919"
            strokeWidth="1.13862"
          />
          <path
            d="M36.2108 34.3335C35.905 34.3335 35.6117 34.212 35.3954 33.9958C35.1791 33.7795 35.0576 33.4862 35.0576 33.1803C35.0576 32.8745 35.1791 32.5811 35.3954 32.3649C35.6117 32.1486 35.905 32.0271 36.2108 32.0271"
            stroke="#191919"
            strokeWidth="1.13862"
          />
          <path
            d="M36.2109 34.3335C36.5168 34.3335 36.8101 34.212 37.0264 33.9958C37.2427 33.7795 37.3642 33.4862 37.3642 33.1803C37.3642 32.8745 37.2427 32.5811 37.0264 32.3649C36.8101 32.1486 36.5168 32.0271 36.2109 32.0271"
            stroke="#191919"
            strokeWidth="1.13862"
          />
          <path
            d="M50.0497 34.3335C49.7438 34.3335 49.4505 34.212 49.2343 33.9958C49.018 33.7795 48.8965 33.4862 48.8965 33.1803C48.8965 32.8745 49.018 32.5811 49.2343 32.3649C49.4505 32.1486 49.7438 32.0271 50.0497 32.0271"
            stroke="#191919"
            strokeWidth="1.13862"
          />
          <path
            d="M50.0493 34.3335C50.3552 34.3335 50.6485 34.212 50.8648 33.9958C51.081 33.7795 51.2025 33.4862 51.2025 33.1803C51.2025 32.8745 51.081 32.5811 50.8648 32.3649C50.6485 32.1486 50.3552 32.0271 50.0493 32.0271"
            stroke="#191919"
            strokeWidth="1.13862"
          />
          <path
            d="M78.2219 50.6908H105.308V81.9435H78.2219V50.6908Z"
            fill="#66E1FF"
          />
          <path
            d="M105.308 77.7202L78.2782 50.6908H105.308V77.7202Z"
            fill="#C2F3FF"
          />
          <path
            d="M105.308 86.1106V81.9436H78.2219V86.1106C78.2252 87.2148 78.6653 88.2728 79.4461 89.0535C80.2268 89.8343 81.2848 90.2744 82.389 90.2777H101.141C102.245 90.2744 103.303 89.8343 104.083 89.0535C104.864 88.2728 105.304 87.2148 105.308 86.1106Z"
            fill="white"
          />
          <path
            d="M78.2219 46.5237V50.6908H105.308V46.5237C105.304 45.4196 104.864 44.3616 104.083 43.5808C103.303 42.8001 102.245 42.36 101.141 42.3567H82.389C81.2848 42.36 80.2268 42.8001 79.4461 43.5808C78.6653 44.3616 78.2252 45.4196 78.2219 46.5237Z"
            fill="white"
            stroke="#191919"
            strokeWidth="1.13862"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M61.5535 69.4426H82.3886C83.4928 69.4459 84.5508 69.886 85.3315 70.6668C86.1123 71.4475 86.5524 72.5055 86.5557 73.6097V86.1108C86.5524 87.2149 86.1123 88.2729 85.3315 89.0536C84.5508 89.8344 83.4928 90.2745 82.3886 90.2778H61.5535C60.4483 90.2778 59.3884 89.8388 58.6069 89.0573C57.8255 88.2758 57.3864 87.2159 57.3864 86.1108V73.6097C57.3864 72.5045 57.8255 71.4446 58.6069 70.6631C59.3884 69.8817 60.4483 69.4426 61.5535 69.4426Z"
            fill="#FFEF5E"
          />
          <path
            d="M82.3886 69.4426C83.4928 69.4459 84.5508 69.886 85.3315 70.6668C86.1123 71.4475 86.5524 72.5055 86.5557 73.6097V86.1108C86.5539 86.6863 86.4322 87.2552 86.1983 87.7811C85.9644 88.307 85.6234 88.7784 85.1972 89.1652L65.4747 69.4426H82.3886Z"
            fill="#FFF9BF"
          />
          <path
            d="M78.2217 65.2754V50.6908"
            stroke="#191919"
            strokeWidth="1.13862"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M57.3864 73.6097V75.6932H86.5557V73.6097C86.5524 72.5055 86.1123 71.4475 85.3315 70.6668C84.5508 69.886 83.4928 69.4459 82.3886 69.4426H61.5535C60.4483 69.4426 59.3884 69.8817 58.6069 70.6631C57.8255 71.4446 57.3864 72.5045 57.3864 73.6097Z"
            stroke="#191919"
            strokeWidth="1.13862"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M57.3864 75.6931V86.1107C57.3864 87.2159 57.8255 88.2758 58.6069 89.0572C59.3884 89.8387 60.4483 90.2777 61.5535 90.2777H82.3886C83.4928 90.2744 84.5508 89.8343 85.3315 89.0536C86.1123 88.2728 86.5524 87.2148 86.5557 86.1107V75.6931H57.3864Z"
            stroke="#191919"
            strokeWidth="1.13862"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M105.308 50.6908V86.1106C105.304 87.2147 104.864 88.2727 104.083 89.0534C103.303 89.8342 102.245 90.2743 101.141 90.2776H90.723"
            stroke="#191919"
            strokeWidth="1.13862"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M90.723 81.9436H105.308"
            stroke="#191919"
            strokeWidth="1.13862"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M71.9711 79.8599H82.3887"
            stroke="#191919"
            strokeWidth="1.13862"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M78.2216 84.027H82.3887"
            stroke="#191919"
            strokeWidth="1.13862"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </SvgIcon>
    );
  })
);
